import { fetchApi } from 'Utils/utils';

let searchOrders = function(params) {
  return fetchApi.post('/api/v1/order/search/', params);
};

let findOne = function(id) {
  return fetchApi.get(`/api/v1/order/${id}/`);
};

export { searchOrders, findOne };
